import api from '@/utils/axios';

class BasketService {
  /**
   * 바스켓 생성
   * @param {string} name - 바스켓 이름
   * @param {string[]} bondCodes - 채권 코드 배열
   */
  async createBasket(name, bondCodes) {
    try {
      const response = await api.post('/api/v1/baskets', {
        name,
        bondCodes
      });
      return response;
    } catch (error) {
      console.error('바스켓 생성 실패:', error);
      throw error;
    }
  }

  /**
   * 사용자의 바스켓 목록 조회 (아이템 포함)
   */
  async getBasketsWithItems() {
    try {
      const response = await api.get('/api/v1/baskets');
      return response || [];
    } catch (error) {
      console.error('바스켓 목록 조회 실패:', error);
      throw error;
    }
  }
  

  /**
   * 사용자의 바스켓 목록 조회 (아이템 제외)
   */
  async getBaskets() {
    try {
      const response = await api.get('/api/v1/baskets/simple');
      return response || [];
    } catch (error) {
      console.error('바스켓 목록 조회 실패:', error);
      throw error;
    }
  }

  /**
   * 특정 바스켓의 아이템 목록 조회
   * @param {number} basketId - 바스켓 ID
   */
  async getBasketItems(basketId) {
    try {
      const response = await api.get(`/api/v1/baskets/${basketId}/items`);
      return response || [];
    } catch (error) {
      console.error('바스켓 아이템 조회 실패:', error);
      throw error;
    }
  }

  /**
   * 바스켓 이름 변경
   * @param {number} basketId - 바스켓 ID
   * @param {string} name - 새로운 이름
   */
  async updateBasketName(basketId, name) {
    try {
      const response = await api.patch(`/api/v1/baskets/${basketId}/name`, {
        name
      });
      return response;
    } catch (error) {
      console.error('바스켓 이름 변경 실패:', error);
      throw error;
    }
  }

  /**
   * 바스켓 삭제
   * @param {number} basketId - 바스켓 ID
   */
  async deleteBasket(basketId) {
    try {
      const response = await api.delete(`/api/v1/baskets/${basketId}`);
      return response;
    } catch (error) {
      console.error('바스켓 삭제 실패:', error);
      throw error;
    }
  }

  /**
   * 바스켓에 아이템 추가
   * @param {number} basketId - 바스켓 ID
   * @param {string} bondCode - 채권 코드
   */
  async addBasketItem(basketId, bondCode) {
    try {
      const response = await api.post(`/api/v1/baskets/${basketId}/items`, {
        bondCode
      });
      return response;
    } catch (error) {
      console.error('바스켓 아이템 추가 실패:', error);
      throw error;
    }
  }

  /**
   * 바스켓 아이템 제거
   * @param {number} basketId - 바스켓 ID
   * @param {number} itemId - 아이템 ID
   */
  async removeBasketItem(basketId, itemId) {
    try {
      const response = await api.delete(`/api/v1/baskets/${basketId}/items/${itemId}`);
      return response;
    } catch (error) {
      console.error('바스켓 아이템 제거 실패:', error);
      throw error;
    }
  }
}

export default new BasketService();
